import React from 'react';
import CustomSelect from '../../components/customSelect/CustomSelect';
import {
  VideoOrderEnum,
  RegionCodeEnum,
  VideoTypeEnum,
  MaxResultsEnum,
  SearchSettingsEnum,
} from '../../types/types';
import './_searchBar.scss';

export default function SearchBar() {
  return (
    <div className="search-bar">
      <div className="search-bar__title">Search settings:</div>
      <CustomSelect options={VideoOrderEnum} name={SearchSettingsEnum.videoOrder} />
      <CustomSelect options={RegionCodeEnum} name={SearchSettingsEnum['regionCode']} />
      <CustomSelect options={VideoTypeEnum} name={SearchSettingsEnum.videoType} />
      <div className="search-bar__title">Pagination:</div>
      <CustomSelect options={MaxResultsEnum} name={SearchSettingsEnum.maxResults} />
    </div>
  );
}
